import { Company } from './company';
import { useIdentityStore } from './store';
import { User } from './user';

export const getCurrentUser = async () => {
	return new Promise<User>((resolve) => {
		const user = useIdentityStore.getState().user;

		if (user) {
			return resolve(user);
		}

		const unsubscribe = useIdentityStore.subscribe((state) => {
			if (state.user) {
				unsubscribe();
				return resolve(state.user);
			}
		});
	});
};

export const getCurrentCompany = async () => {
	return new Promise<Company>((resolve) => {
		const company = useIdentityStore.getState().company;

		if (company) {
			return resolve(company);
		}

		const unsubscribe = useIdentityStore.subscribe((state) => {
			if (state.company) {
				unsubscribe();
				return resolve(state.company);
			}
		});
	});
};
